<template>
  <header :class="{ready}">

    <TransitionGroup name="slide-fade" mode="out-in">
      <div class="slide"
        v-for="post in posts"
        :class="{active: currentSlide.id == post.id}"
        :key="post.id"
        v-show="currentSlide.id == post.id">
        <img :src="post.images.original" alt="" @load="imgSettled" @error="imgSettled">
      </div>
    </TransitionGroup>

    <SlideInfo :posts="posts"
      v-if="ready"
      :currentSlideIndex="currentSlideIndex"
      @update:currentSlideIndex="currentSlideIndex = $event" />

  </header>
</template>

<script>
    import SlideInfo from '@/components/HeroHeader/SlideInfo.vue';

    export default {
        name: 'HeroHeader',
        components: {
            SlideInfo,
        },
        props: {
            category: {
                type: String,
                default: 'hero',
            },
            limit: {
                type: Number,
                default: 3,
            },
        },
        data() {
            return {
                currentSlideIndex: 0,
                canLoad: true,
                settledImagesNumber: 0,
            }
        },
        methods: {
            imgSettled() {
                this.settledImagesNumber++;
            },
        },
        computed: {
            currentSlide() {
                if( this.posts.length ) {
                    return this.posts[this.currentSlideIndex];
                }
                return null
            },
            postsCategory() {
                return this.$store.getters['categories/slug'](this.category)
            },
            posts() {
                if( this.postsCategory == null ) {
                    return  []
                }
                return this.$store.getters["posts/category"](this.postsCategory, this.limit, true)
            },
            postsWithImage() {
                return this.posts.filter(post => post.images && post.images.original)
            },
            ready() {
                if( this.posts.length == 0 ) return false
                return this.settledImagesNumber >= this.postsWithImage.length && this.canLoad
            },
        },
        watch: {
            ready() {
                if( this.ready ) {
                    this.$emit('ready');
                }
            },
        },
        async mounted() {
            const [category] = await this.$store.dispatch('categories/getOne', this.category)
            if( category == null ) return
            this.$store.dispatch('posts/getCategoryById', category.id)
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/_colors.scss";
@import "@/assets/scss/_effects.scss";
@import "@/assets/scss/queries";

header {
  --hero-height: 50vh;
  --hero-margin: 0;

  @include media(sm) {
      --hero-height: calc( 9 / 16 * var(--content-width));
      --hero-margin: 0 0 calc(var(--content-width) * -.15);
  }

  width: 100%;
  background-size: cover;
  position: relative;
  z-index: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 1s;
  transition-timing-function: cubic-bezier(0.85, 0, 0.15, 1);
  transition-property: opacity, transform;

  margin: var(--hero-margin);


  min-height: var(--hero-height);

  &:not(.ready) {
    opacity: 0;
    transform: translateY(-50%);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: calc(100% - 1px);
    background:
      linear-gradient(
      0deg,
      rgba($color-background, 1) 0%,
      rgba($color-background, .5) 40%,
      rgba($color-background, 0) 100%
      );
    z-index: 10;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
  }

  .slide {
    background-image: var(--background-image);
    background-size: cover;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 4;
    &.active {
      z-index: 2;
    }
  }
}
</style>
